export const faqData = [
    {
      question: "What Is Food Menu Feature?",
      answer:
        "Dear customer, with the help of food menu feature you can see previous & upcoming food menu of the month selecting date column.",
    },
    {
      question: "What Is My Billings Feature?",
      answer:
        "Dear customer, with the help of My billings feature you can check all the details of the transaction you have made for the paln subscription.",
    },
    {
      question: "What Is Meal Trackings Feature?",
      answer:
        "Dear customer, with the help of meal tracking feature you can track the dates you have made cancel request and how many meals have been delivered to you.",
    },
    {
      question: "What Is Cancel Meal Request Feature?",
      answer:
        "Dear customer, with cancel meal request feature you can raise a request to cancel the meal for that day and future dates. please note you can raise cancel request from 12 Mid Night To Morning 11 for lunch & 12 Mid Night Till 4:30 PM for dinner.",
    },
    {
      question: "What Is Customize Meal Feature?",
      answer:
        "Dear customer, customize meal feature , when you want to get something changed in you dish from today menu but please note you can raise cancel request from 12 Mid Night To Morning 11 for lunch & 12 Mid Night Till 4:30 PM for dinner.",
    },
    {
      question: "What Is Subscription Plans Feature?",
      answer:
        "Dear Customer, subscription plans will show which plan you have opted currently and you can simply choose or upgrade to another plan.",
    },
    {
      question: "What Is Help Feature?",
      answer:
        "Dear customer, Help feature is a form where you can raise a query around any subject related to webapp we will assist you within 24 hours.",
    },
    {
      question: "What Is Chat On WhatsApp Feature?",
      answer:
        "Dear customer, chat on Whatsapp is feature which enables you to chat directly to our customer care number, please note wait time may be higher due to support team might be busy with other customers.",
    },
  ];